import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { GenericPageLayout } from '@layout/GenericPageLayout';
import { TripTypes, ERROR_CODES, Destination } from '@model/common';
import { PageProps } from '@model/pages';
import { PageConfig } from '@model/content';
import { Error500 } from '@components/common/hero/error/Error500';
import { setTripTypeFilter } from '@state/slices/navigation';

/* ***************** *
 *       Types       *
 * ***************** */
export interface TravelGuidesListPageLayoutProps extends PageProps {
  pageConfig: PageConfig;
  destination: Destination;
  path: string;
  tripType?: TripTypes;
  promoBannerTripType: TripTypes;
}

export const TravelGuidesListPageLayout = ({
  pageConfig,
  destination,
  path,
  tripType,
  promoBannerTripType
}: TravelGuidesListPageLayoutProps) => {
  if (!pageConfig) return <Error500 code={ERROR_CODES.NO_CMS_CONFIG} />;

  const { components, type } = pageConfig;

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setTripTypeFilter(tripType || TripTypes.ALL));
  }, []);

  return (
    <GenericPageLayout
      components={components}
      destination={destination}
      tripType={tripType}
      path={path}
      type={type}
      promoBannerTripType={promoBannerTripType}
    />
  );
};
